module.exports = __webpack_public_path__ + "static/learn-decide-5d33957aec9db0be52957aa0d61fac53.svg";